<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { Base600Orange, Sm400Gray, Sm600Orange } from '~/components/typography'
import LogoIconFramed from '~/components/ui/LogoIconFramed/LogoIconFramed.vue'
import VCard from '~/components/ui/VCard.vue'

import { useMiscResizeStore } from '~/stores/miscResize'

import { Breakpoints } from '~/enums/breakpoints'

type Props = {
  link?: string
  title?: string
  description?: string
  linkTarget?: '_blank' | '_self'
}
type Emits = {
  click: [event: MouseEvent]
}
type Slots = {
  title(): any
  description(): any
}

withDefaults(defineProps<Props>(), {
  link: '',
  title: '',
  description: '',
  linkTarget: '_blank',
})
const emit = defineEmits<Emits>()
defineSlots<Slots>()

const { SCREEN_WIDTH } = storeToRefs(useMiscResizeStore())
</script>

<template>
  <a
    :href="link"
    :target="linkTarget"
    rel="noopener"
    @click="emit('click', $event)"
  >
    <VCard class="helpBlockContainer" padding="4">
      <div class="tw-flex">
        <LogoIconFramed size="lg" class="tw-mr-sm 375:tw-mr-lg" />
        <div class="tw-flex tw-flex-col">
          <component
            :is="SCREEN_WIDTH < Breakpoints.md ? Sm600Orange : Base600Orange"
            class="375:tw-mb-2"
          >
            <slot name="title">{{ title }}</slot>
          </component>
          <Sm400Gray
            v-if="SCREEN_WIDTH >= Breakpoints.xs375"
            class="description"
          >
            <slot name="description">{{ description }}</slot>
          </Sm400Gray>
        </div>
      </div>
      <Sm400Gray
        v-if="SCREEN_WIDTH < Breakpoints.xs375"
        class="description tw-mt-2"
      >
        <slot name="description">{{ description }}</slot>
      </Sm400Gray>
    </VCard>
  </a>
</template>

<style scoped lang="scss">
.helpBlockContainer {
  @apply tw-bg-orange-100;
  box-shadow: var(--shadow-picture);
  &:hover {
    box-shadow: var(--shadow-picture-dark);
  }
}

.description {
  -webkit-line-clamp: 3;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
</style>
